import React, { useCallback, useEffect, useState } from "react";
import HeroNavbar from "common/HeroNavbar";
import CountDown from "common/CountDown";
import { useLocation } from "react-router-dom";
import EliteVacancesFooter from "common/TravelFooter/EliteVacancesFooter";

const MainLayout = ({ children }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";
  const [isScrolled, setIsScrolled] = useState(() => {
    if (typeof window === "undefined") return !isHomePage;
    const isMobile = window.matchMedia("(max-width: 1000px)").matches;
    return !isHomePage || isMobile;
  });

  const handleScroll = useCallback(() => {
    if (!isHomePage) return;

    const isMobile = window.matchMedia("(max-width: 1000px)").matches;
    if (isMobile) return;

    const offset = window.scrollY;
    setIsScrolled(offset > 200);
  }, [isHomePage]);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 1000px)");
    const syncMobileNav = () => {
      if (isHomePage && mq.matches) {
        setIsScrolled(true);
      }
    };

    syncMobileNav();
    mq.addEventListener("change", syncMobileNav);
    window.addEventListener("scroll", handleScroll);

    return () => {
      mq.removeEventListener("change", syncMobileNav);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isHomePage, handleScroll]);

  return (
    <>
      <header>
        <HeroNavbar isScrolled={isScrolled} isHomePage={isHomePage} />
      </header>
      <CountDown targetDate="2024-11-29T23:59:59Z" />
      <main>{children}</main>
      <EliteVacancesFooter />
    </>
  );
};

export default MainLayout;
